import React from 'react';

import { useSearchParams } from 'react-router-dom';

export const useTableParams = (defaultCurrent = 1, defaultPageSize = 10) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const current = Number(searchParams.get('current')) || defaultCurrent;
  const pageSize = Number(searchParams.get('pageSize')) || defaultPageSize;

  React.useEffect(() => {
    setPagination(current, pageSize);
  }, []);

  const setPagination = (newCurrent: number, newPageSize: number) => {
    const params = new URLSearchParams(searchParams);
    params.set('current', String(newCurrent));
    params.set('pageSize', String(newPageSize));
    setSearchParams(params);
  };

  const resetParams = () => {
    const params = new URLSearchParams(searchParams);
    params.delete('current');
    params.delete('pageSize');
    setSearchParams(params);
  };

  return { current, pageSize, setPagination, resetParams };
};
